import type { OcrWarning } from '@practium/features/api';

interface SampleWithId {
	sampleId?: string;
}

export const findOcrWarningForSample = (
	warnings: OcrWarning[] | undefined,
	sample: SampleWithId | undefined
): OcrWarning | undefined => {
	if (!sample?.sampleId) return undefined;
	return warnings?.find((warning) => warning.sampleId === sample.sampleId);
};
